export const getCountrySize = (countryCode, category = 'swim') => {
  const sizeData = {
    'US': {
      label: 'US',
      xs: '0-2',
      s: '2-4',
      m: '6-8',
      l: '8-10',
      xl: '10-12',
      xxl: '12-14',
    },
    'AUS': {
      label: 'AUS',
      xs: '6',
      s: '8-10',
      m: '8-10',
      l: '10-12',
      xl: '12-14',
      xxl: '14-16',
    },
    'EU': {
      label: 'EU',
      xs: '34-36',
      s: '36-38',
      m: '40-42',
      l: '44-46',
      xl: '46-48',
      xxl: '48-50',
    },
    'UK': {
      label: 'UK',
      xs: '6',
      s: '8-10',
      m: '10-12',
      l: '12-14',
      xl: '14-16',
      xxl: '16-18',
    },
  }

  return sizeData[countryCode]
}

export const getMensApparelData = (id) => {
  const apparelData = {
    "swim-shorts": [
      {
        label: "WAIST BAND",
        s: "28-32”",
        m: "30-35”",
        l: "33-37”",
        xl: "34-38”",
        xxl: "35-39”",
      },
      {
        label: "THIGH CIRCUMFERENCE",
        s: '18-19"',
        m: '19-22"',
        l: '20-23"',
        xl: '20-24"',
        xxl: '21-26"',
      },
      {
        label: "INSEAM",
        s: '5"',
        m: '5"',
        l: '5.5"',
        xl: '5.5"',
        xxl: '5.5"',
      },
      {
        label: "LENGTH",
        s: '15"',
        m: '15"',
        l: '15.5"',
        xl: '16.5"',
        xxl: '16.5"',
      },
    ],
    "board-shorts": [
      {
        label: "WAIST",
        s: '29"',
        m: '30.5"',
        l: '32"',
        xl: '34"',
      },
      {
        label: "HIPS",
        s: '40"',
        m: '43"',
        l: '45"',
        xl: '47"',
      },
      {
        label: "INSEAM",
        s: '14.5"',
        m: '15"',
        l: '16"',
        xl: '16.5"',
      },
      {
        label: "LENGTH",
        s: '4"',
        m: '4.2"',
        l: '4.4"',
        xl: '4.6"',
      },
    ],
    "polo-shirts": [
      {
        label: "CHEST WIDTH",
        s: '20"',
        m: '21"',
        l: '22"',
        xl: '24"',
      },
      {
        label: "WAIST",
        s: '33"',
        m: '35"',
        l: '37"',
        xl: '39"',
      },
      {
        label: "LENGTH",
        s: '28.5"',
        m: '29.5"',
        l: '30.5"',
        xl: '31.5"',
      },
    ],
  };

  return apparelData[id]
}

export const metricOptions = [
  {id: "in", label: 'IN'},
  {id: "cm", label: 'CM'},
]

export const countrySizeOptions = [
  {id: "us", label: 'US'},
  {id: "uk", label: 'UK'},
  {id: "eu", label: 'EU'},
  {id: "aus", label: 'AUS'},
]

export const menApparelOptions = [
  {id: 'swim-shorts', label: "MEN'S SWIM SHORTS"},
  {id: 'board-shorts', label: "MEN'S BOARD SHORTS"},
  {id: 'polo-shirts', label: "MEN'S POLO SHIRTS"},
]

export const sizeOptions = [
  {id: 'xs', label: 'Extra Small', value: 'filter_xs'},
  {id: 's', label: 'Small', value: 'filter_s'},
  {id: 'm', label: 'Medium', value: 'filter_m'},
  {id: 'l', label: 'Large', value: 'filter_l'},
  {id: 'xl', label: 'Extra Large', value: 'filter_xl'},
  {id: 'xxl', label: 'Double Extra Large', value: 'filter_xxl'},
  {id: 'fs', label: 'Free Size', value: 'no-variants'},
]

export const coverageTopOptions = [
  {id: 'bandeau', label: 'Bandeau', value: 'filter_bandeau'},
  {id: 'bralette', label: 'Bralette', value: 'filter_bralette'},
  {id: 'triangle', label: 'Triangle', value: 'filter_triangle'},
  {id: 'underwire', label: 'Underwire', value: 'filter_underwire'},
  {id: 'onepiece', label: 'One Piece', value: 'filter_onepiece'},
]

export const coverageBottomOptions = [
  {id: 'adjustable', label: 'Adjustable', value: 'filter_adjustable'},
  {id: 'cheeky', label: 'Cheeky', value: 'filter_cheeky'},
  {id: 'modest', label: 'Modest', value: 'filter_modest'},
  {id: 'botmedium', label: 'Medium', value: 'filter_medium'},
  {id: 'tease', label: 'Tease', value: 'filter_tease'}
]

export const printedOptions = [
  {id: 'animal', label: 'Animal', value: 'filter_animal'},
  //{id: 'dotted', label: 'Dotted', value: 'filter_adjustable'},
  {id: 'floral', label: 'Floral', value: 'filter_floral'},
  {id: 'geometric', label: 'Geometric', value: 'filter_geometric'},
  {id: 'striped', label: 'Striped', value: 'filter_striped'},
]

export const texturedOptions = [
  {id: 'eyelet', label: 'Eyelet', value: 'filter_eyelet'},
  {id: 'jacquard-terry', label: 'Jacquard', value: 'filter_jacquard'},
  {id: 'pointelle', label: 'Pointelle', value: 'filter_pointelle'},
  {id: 'shimmer', label: 'Shimmer', value: 'filter_shimmer'},
  {id: 'smocked', label: 'Smocked', value: 'filter_smocked'},
]

export const ratingOptions = [
  {id: 1, value: 1},
  {id: 2, value: 2},
  {id: 3, value: 3},
  {id: 4, value: 4},
  {id: 5, value: 5},
]

export const sizeVariants = [
  {label: 'XS', displayValue: 'EXTRA SMALL'},
  {label: 'S', displayValue: 'SMALL'},
  {label: 'M', displayValue: 'MEDIUM'},
  {label: 'L', displayValue: 'LARGE'},
  {label: 'XL', displayValue: 'EXTRA LARGE'},
  {label: 'XXL', displayValue: 'DOUBLE EXTRA LARGE'},
]

export const getSizeName = (size) => {
  const sizeName = sizeVariants.find((item) => item.label === size);
  return sizeName ? sizeName.displayValue.toLowerCase() : "Unknown Size";
}